import { Organization, resolveAddress, toNetwork } from '@1hive/connect-core';
import { normalizeConnector, normalizeEthersProvider, normalizeIpfsResolver, } from './normalizers';
async function connect(location, connector, { actAs, ethereum: ethereumProvider, ipfs, network, verbose, } = {}) {
    var _a;
    const _network = toNetwork(network !== null && network !== void 0 ? network : 'ethereum');
    const ethersProvider = normalizeEthersProvider(ethereumProvider, _network);
    const orgConnector = normalizeConnector(connector, _network);
    const orgAddress = await resolveAddress(ethersProvider, location);
    const connectionContext = {
        actAs: actAs || null,
        ethereumProvider: ethereumProvider || null,
        ethersProvider,
        ipfs: normalizeIpfsResolver(ipfs),
        network: _network,
        orgAddress,
        orgConnector,
        orgLocation: location,
        verbose: verbose !== null && verbose !== void 0 ? verbose : false,
    };
    await ((_a = orgConnector.connect) === null || _a === void 0 ? void 0 : _a.call(orgConnector, connectionContext));
    return new Organization(connectionContext);
}
export default connect;
